import React, { useState, useMemo } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { Button } from '@components';
import { getLanguageId } from '@helpers/language';
import { translatePrice } from '@/helpers/product';
import PickerModal from './PickerModal';
import styles from './BuildAppNavigationProduct.module.scss';

const DynamicImage = dynamic(() => import('@components/DynamicImage'), { ssr: false });

export default function BuildAppNavigationProduct({ product, selectClicked }) {
  const { locale } = useRouter();
  const [show, setShow] = useState(false);

  const langId = getLanguageId(locale);

  const featuresText = useMemo(() => (
    product?.QuickFeatures?.map(feature => feature.FeatureText[langId].FeatureTitle + " " + feature.FeatureText[langId].FeatureText)
  ), [product]);

  const hasBQA = useMemo(() => (
    product?.Tags?.reduce((val, tag) => {
      return val || (tag.TagCode === 'BuildQuote' && tag.Value === 'BQA');
    }, false)
  ), [product]);

  const buttonText = useMemo(() => {
    /*if (hasBQA) {
      if (false) {
        return locale == 'fr' ? 'Choisissez un forfait' : 'Choose a package';
    } else {*/
      return locale == 'fr' ? 'Personnaliser' : 'Customize';
   // }
  }, [hasBQA]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
  /*  if (hasBQA) {
      if (hasBQA) {
        setShow(true);
    } else {*/
      selectClicked(product?.ProductId);
    //}
  }

  return (
    <div className={styles.buildAppNavigationProduct} key={product?.ProductId} >
      <div className={styles.image} onClick={handleShow}>
        <DynamicImage
          imgSrc={`/api/static/media/byfile/Products/${product?.ProductCode}/Studio/1_N_N_N_I_640x640.png`}
          size={"640x640"}
        />
      </div>
      <div className={styles.bgCircle}></div>
      <br/>
      <div className={styles.title}>{product?.Title}</div>
      <div className={styles.msrp}>
        {/*locale == 'fr' ? 'À partir de' : 'Starting from'*/} {/* <span className={styles.price}>{translatePrice(product?.SellPrice, locale)}</span> */}
      </div>
      <div className={styles.description}>{product?.SmallDescription}</div>
      {featuresText &&
        <div className={styles.features}>
          <ul>
            {featuresText.map((feature, idx) => {
              const firstColon = feature.indexOf(':');
              const firstChunk = feature.substring(0, firstColon + 1);
              const secondChunk = feature.substring(firstColon + 1);
              return (
                <li key={idx}>{firstChunk} <div className={styles.highlight}>{secondChunk}</div></li>
              )
            })}
          </ul>
        </div>
      }
      <div className={styles.selectButton}>
        <Button animated onClick={handleShow}>
          {buttonText}
        </Button>
      </div>

      {show && (
        <PickerModal
          productId={product.ProductId}
          show={show}
          onHide={handleClose}
          selectClicked={selectClicked}
        />
      )}
    </div>
  );
}
